<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div>
    <section v-if="loading" class="d-flex align-items-center">
      <b-spinner variant="primary" label="Loading"></b-spinner> <p class="ml-1 mb-0">Finding Devices...</p>
    </section>
    <section v-else>
      <section v-if="cameraOptions.length === 0">
        <p>Could not find camera options</p>
      </section>
      <section v-else class="row">
        <section class="col-6">
          <section class="mb-1">
            <label>Select Camera</label>
            <b-form-select v-model="selectedCameraId" @change="start">
              <b-form-select-option value="" disabled>Select an option</b-form-select-option>
              <b-form-select-option v-for="option in cameraOptions" :value="option.deviceId" :key="option.deviceId">
                {{ option.label }}
              </b-form-select-option>
            </b-form-select>
          </section>

          <section class="mb-1">
            <label>Select Microphone</label>
            <b-form-select v-model="selectedAudioInputId" @change="start">
              <b-form-select-option value="" disabled>Select an option</b-form-select-option>
              <b-form-select-option v-for="option in microphoneOptions" :value="option.deviceId" :key="option.deviceId">
                {{ option.label }}
              </b-form-select-option>
            </b-form-select>
          </section>

          <section class="mb-1">
            <label>Select Speaker</label>
            <b-form-select v-model="selectedAudioOutputId" @change="changeAudioDestination">
              <b-form-select-option value="" disabled>Select an option</b-form-select-option>
              <b-form-select-option v-for="option in speakerOptions" :value="option.deviceId" :key="option.deviceId">
                {{ option.label }}
              </b-form-select-option>
            </b-form-select>
          </section>

          <section>
            <b-btn variant="primary" @click="getDevices" class="full-width">
              <span class="fa fa-sync"></span> Refresh Devices
            </b-btn>
          </section>
        </section>
        <section class="col-6">
          <video class="full-width" id="preview" playsinline autoplay></video>
        </section>

        <div class="col-12">
          <b-btn class="mt-2 full-width" @click="chooseCamera()" :disabled="!validChoose()" variant="primary">Choose
            Camera
          </b-btn>
        </div>
      </section>
    </section>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { logger } from '@/util/logger';

export default {
  components: {},
  props: {},
  data() {
    return {
      loading: true,
      cameraOptions: [],
      microphoneOptions: [],
      speakerOptions: [],
      cameraKey: 'cameraDeviceId',
      microphoneKey: 'audioInputDeviceId',
      speakerKey: 'audioOutputDeviceId',
      selectedCameraId: null,
      selectedAudioInputId: null,
      selectedAudioOutputId: null,
    };
  },
  mounted() {
    this.getDevices();
    this.presetSelectedDevicesFromLocal();
  },
  beforeDestroy() {
    this.stopTracks();
  },
  methods: {
    getDevices() {
      this.loading = true;
      this.cameraOptions = [];
      this.microphoneOptions = [];
      this.speakerOptions = [];
      navigator.mediaDevices.enumerateDevices()
        .then(cameraOptions => {
          if (cameraOptions && cameraOptions.length > 0) {
            cameraOptions.forEach(device => {
              if (device.kind === 'videoinput') {
                this.cameraOptions.push({
                  deviceId: device.deviceId,
                  label: device.label || `Camera ${this.cameraOptions.length + 1}`,
                });
              } else if (device.kind === 'audioinput') {
                this.microphoneOptions.push({
                  deviceId: device.deviceId,
                  label: device.label || `Microphone ${this.cameraOptions.length + 1}`,
                });
              } else if (device.kind === 'audiooutput') {
                this.speakerOptions.push({
                  deviceId: device.deviceId,
                  label: device.label || `Speaker ${this.cameraOptions.length + 1}`,
                });
              }
            });
          }
        })
        .catch(err => {
          logger.error('Cannot get cameraOptions', err, null, 'ChooseCameraAndAudio:getCameras');
          this.$toast.error('Error getting camera devices', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 1000); // show loader for at least a second to stop flickering
      });
    },
    start() {
      this.stopTracks();
      const constraints = {
        audio: { deviceId: this.selectedAudioInputId ? { exact: this.selectedAudioInputId } : undefined },
        video: { deviceId: this.selectedCameraId ? { exact: this.selectedCameraId } : undefined },
      };
      navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        window.stream = stream;
        const preview = document.getElementById('preview');
        preview.srcObject = stream;
      });
    },
    stopTracks() {
      if (window.stream) {
        window.stream.getTracks().forEach(track => {
          track.stop();
        });
      }
    },
    changeAudioDestination() {
      this.attachSinkId(document.getElementById('preview'), this.selectedAudioOutputId);
    },
    attachSinkId(element, sinkId) {
      if (typeof element.sinkId !== 'undefined') {
        element.setSinkId(sinkId)
          .then(() => {
            logger.message(`Success, audio output device attached: ${sinkId}`);
          })
          .catch(error => {
            logger.error('Error setting sinkId', error, null, 'ChooseCameraAndAudio:attachSinkId - set sinkId');
            // Jump back to first output device in the list as it's the default.
            audioOutputSelect.selectedIndex = 0; // eslint-disable-line
          });
      } else {
        logger.warn('Browser does not support output device selection.', null, null, 'ChooseCameraAndAudio:attachSinkId');
      }
    },
    validChoose() {
      const validCamera = this.selectedCameraId && this.selectedCameraId.length > 0;
      const validAudioInput = this.selectedAudioInputId && this.selectedAudioInputId.length > 0;
      const validAudioOutput = this.selectedAudioOutputId && this.selectedAudioOutputId.length > 0;
      return validCamera && validAudioInput && validAudioOutput;
    },
    chooseCamera() {
      localStorage.setItem(this.cameraKey, this.selectedCameraId);
      localStorage.setItem(this.microphoneKey, this.selectedAudioInputId);
      localStorage.setItem(this.speakerKey, this.selectedAudioOutputId);
      this.$toast.success('Camera and Audio selections have been saved', {
        toastClassName: ['toast-std', 'success-toast'],
      });
      this.$emit('close', true);
    },
    presetSelectedDevicesFromLocal() {
      this.selectedCameraId = localStorage.getItem(this.cameraKey);
      this.selectedAudioInputId = localStorage.getItem(this.microphoneKey);
      this.selectedAudioOutputId = localStorage.getItem(this.speakerKey);
    },
  },
};
</script>
